import styled from "styled-components";

export const StyledMessage = styled.div`
  color: ${(props) => props.theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.error};
  font-size: 14px;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 5px;
  height: 28px;
`;
export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
